import React from 'react';

// Components
import MetaTags from 'components/MetaTags';
import PageHeader from 'components/PageHeader';

// Containers
import GenericOCRPitchPage from 'containers/GenericOCRPitchPage';

const GenericOCR = () => (
  <>
    <PageHeader>BharatOCR</PageHeader>
    <MetaTags title="Secure ID – BharatOCR" />

    <GenericOCRPitchPage />
  </>
);

export default GenericOCR;
